export class HScodeHelper {
    public static addDotAfterLastTwoNumb(hsCode: string) {
        if (!hsCode)
            return;

        if (!hsCode.match(/^\d+\.\d+\.\d{4}$/g)) {
            return hsCode;
        }

        let arr = hsCode.split(".");
        arr[2] = String.insertStr(arr[2], ".", 2);
        return arr.join(".");
    }
}


// WEBPACK FOOTER //
// ./app/common/helpers/HScodeHelper.ts